<template>
  <div :class="{mark: true, practice: type == 'practice', exam: type == 'exam'}">
    <div class="wrap">
      <span>{{type | tutorialType}}</span>
    </div>
  </div>
</template>

<script>
  import logo from "@/assets/images/excellent_logo.png";
  export default {
    name: "tutorial-type",
    props: ["type", "excellent"],
    data() {
      return {
        logo,
      };
    },
    filters: {
      tutorialType(type) {
        return type == "practice" ? "实践教案": "考试教案";
      },
    },
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .mark {
    position: absolute;
    top: 0;
    left: 0;
    padding: 6px 15px;
    font-size: $font_size_base;
    user-select: none;
    .wrap {
      height: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 15px;
        height: 15px;
        margin: 0 5px 0 0;
      }
    }
  }
  .practice {
    background-color: $color_suc;
  }
  .exam {
    background-color: $color_err;
  }
</style>